import React from 'react';

interface Default3DIconProps {
  size?: number;
  color?: string;
}

export const Default3DIcon = ({ size = 48, color = '#6366f1' }: Default3DIconProps) => {
  const darkerColor = adjustBrightness(color, -30);
  const lighterColor = adjustBrightness(color, 50);

  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Shadow */}
      <ellipse cx="32" cy="58" rx="10" ry="3" fill="rgba(0,0,0,0.2)" />
      {/* Pin tail */}
      <polygon points="24,44 32,60 40,44" fill={darkerColor} />
      {/* Pin body */}
      <circle cx="32" cy="28" r="20" fill={color} />
      {/* 3D highlight arc */}
      <path d="M16 20 C16 10 48 10 48 20" fill={lighterColor} opacity="0.2" />
      {/* Inner circle */}
      <circle cx="32" cy="28" r="12" fill="white" opacity="0.25" />
      <circle cx="32" cy="28" r="8" fill={darkerColor} opacity="0.3" />
      {/* Shine */}
      <circle cx="24" cy="22" r="4" fill="white" opacity="0.3" />
    </svg>
  );
};

function adjustBrightness(hex: string, amount: number): string {
  const num = parseInt(hex.replace('#', ''), 16);
  const r = Math.min(255, Math.max(0, (num >> 16) + amount));
  const g = Math.min(255, Math.max(0, ((num >> 8) & 0x00FF) + amount));
  const b = Math.min(255, Math.max(0, (num & 0x0000FF) + amount));
  return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, '0')}`;
}
